module.exports = __webpack_public_path__ + "img/17.fb69f740.jpg";